import React from "react";

import { Alert } from "@/components/Alert";
import { Accordion } from "@/components/Accordion";
import { Button } from "@/components/Button";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Input } from "@/components/Input";
import { Links } from "@/components/Links";
import { Select } from "@/components/Select";
import { Typography } from "@/components/Typography";
import { Link } from "@/components/Link";
import { ImageUpload } from "@/components/ImageUpload";
import { Checkbox } from "@/components/Checkbox";
import { Divider } from "@/components/Divider";
import { Picker } from "@/components/Picker";
import { ThemePicker } from "@/components/ThemePicker";
import { ListPicker } from "@/components/ListPicker";
import { FilesUpload } from "@/components/FilesUpload";
import { BusinessHours } from "@/components/BusinessHours";
import { ColorGroup } from "@/components/ColorGroup";
import { EventDateAndTime } from "@/components/EventDateTime";
import { CouponDateTime } from "../CouponDateTime";
import { DatePicker } from "../DatePicker";
import { TimezoneSelector } from "../TimezoneSelector";
import { Tabs } from "../Tabs";
import { FramesSelect, FramesTabs } from "@/containers/QREditor/FramesDesign";
import { ListInput } from "@/components/ListInput";
import { ColorPicker } from "../ColorPicker";
import { TemplatesTabs } from "@/containers/QREditor/TemplatesContainer/components/TemplatesTabs/TemplatesTabs";
import {
  TrackingInputs,
  TrackingInputsLib,
} from "@/containers/QREditor/CreateContainer/components/TrackingInputs";
import {
  SwitchWithInput,
  SwitchWithInputLib,
} from "@/containers/QREditor/CreateContainer/components/SwitchWithInput";
import { PickerControlled } from "../PickerControlled/PickerControlled";
import { ColorGroupControlled } from "../ColorGroupControlled";
import { InputControlled } from "../InputControlled";
import { InputAdapter } from "../Input/adapter/InputAdapter";
import { PasswordAdapter } from "../Input/adapter/PasswordAdapter";
import { TextAreaAdapter } from "../Input/adapter/TextareaAdapter";
import { LinksLib } from "../Links/LinksLib";

const DivComponent = ({ dataTestId, ...props }) => {
  return (
    <div
      data-testid={dataTestId}
      {...props}
    >
      {props.children}
    </div>
  );
};

const Components = {
  Accordion: Accordion,
  Alert: Alert,
  Button: Button,
  ButtonLib: ButtonLib,
  BusinessHours: BusinessHours,
  Checkbox: Checkbox,
  Typography: Typography,
  ThemePicker: ThemePicker,
  div: DivComponent,
  Divider: Divider,
  Input: Input,
  InputLib: InputAdapter,
  PasswordLib: PasswordAdapter,
  TextAreaLib: TextAreaAdapter,
  InputControlled: InputControlled,
  ImageUpload: ImageUpload,
  Picker: Picker,
  PickerControlled: PickerControlled,
  ListPicker: ListPicker,
  ListInput: ListInput,
  FilesUpload: FilesUpload,
  Links: Links,
  LinksLib: LinksLib,
  Link: Link,
  Select: Select,
  ColorGroup: ColorGroup,
  ColorGroupControlled: ColorGroupControlled,
  EventDateTime: EventDateAndTime,
  CouponDateTime: CouponDateTime,
  DatePicker: DatePicker,
  TimezoneSelector: TimezoneSelector,
  Tabs: Tabs,
  FramesTabs: FramesTabs,
  TemplatesTabs: TemplatesTabs,
  FramesSelect: FramesSelect,
  ColorPicker: ColorPicker,
  SwitchWithInput: SwitchWithInput,
  SwitchWithInputLib: SwitchWithInputLib,
  TrackingInputs: TrackingInputs,
  TrackingInputsLib: TrackingInputsLib,
};

export default Components;
